import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { SwitchValue } from "components/special/forms";
import { setOnChange } from "components/special";

const DailyCoverPromptData = (props) => {
  const { content, setContent } = props;

  const changeContent = setOnChange(content, setContent);

  return (
    <div>
      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="name" />
        </label>
        <div className="col-8">
          <input
            type="text"
            name="title"
            value={content.title || ""}
            onChange={changeContent}
            className="form-control react-form-input"
            autoComplete="off"
            required
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="text" />
        </label>
        <div className="col-8">
          <textarea
            name="text"
            value={content.text || ""}
            onChange={changeContent}
            className="form-control react-form-input"
            autoComplete="off"
          />
        </div>
      </div>
    </div>
  );
};

export default connect(null, {})(DailyCoverPromptData);
